import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit } from "react-icons/fa";
import { Modal } from 'flowbite-react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../assest/images/37a39cb7092d94d7297953ad09f2dee5.png';
import toast, { Toaster } from 'react-hot-toast';

const Message = ({ onEditSchedule }) => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [details, setDetails] = useState([]);
  const [time, setTime] = useState("--:--");
  const [schedules, setSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [doctorId, setDoctorId] = useState(null);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [selectedAppointments, setSelectedAppointments] = useState([]);
  const [arrivalDate, setArrivalDate] = useState(new Date().toISOString().split('T')[0]);
  const formattedDate = new Date(arrivalDate).toLocaleDateString('en-GB');
  const buildMessage = (row) => {
    return `Dr. ${details.fullName} සමඟ හමුව සදහා ${new Date().toLocaleDateString('en-GB')} වන දින ඔබට ලබාදී ඇති වෙලාව වන ${time}ට පැමිණ සිටින්න. යම්කිසි හේතුවක් මත වෙන්කරවගත් වෙලාව අවලංගු කිරීමට අවශ්‍යනම් ඇමැතුමක් ලබාදී පෙර දැනුම්දීමක් කරනලෙස කරුණාවෙන් ඉල්ලා සිටිමු.
Please arrive at ${time.replace(":", ".")} at the time you have been given to meet Dr. ${details.fullName}, ${new Date().toLocaleDateString('en-GB')}. If you need to cancel your appointment, please call and inform us.
https://www.amarasinghemedicare.com/`;
  };

  const buildArrivalMessage = () => {
    const formattedDate = new Date(arrivalDate).toLocaleDateString('en-GB');
    return `Dr. ${details.fullName} මේ මොහොතේ පැමිණ ඇති අතර ඔබට නියමිත වෙලාවට පැමිණ සිටින්න. මෙම මොහොතේ පරීක්ෂා කරන රෝගී අංකය දැන ගැනීමට පිවිසෙන්න https://www.amarasinghemedicare.com/ හෝ 0777892958 අමතන්න.`;
  };

  const [customMessage, setCustomMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get('https://backend.amarasinghemedicare.com/category/doccategory')
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        setError(error.message);
      });
  }, []);

  const onCloseModal = () => {
    setOpenModal(false);
  };

  const fetchDoctors = async (doctorId) => {
    try {
      const response = await fetch(`https://backend.amarasinghemedicare.com/doctors/doctor/${doctorId}`);

      if (!response.ok) {
        console.error("Error in frontend");
      }

      const data = await response.json();
      setDetails(data);
    } catch (error) {
      console.error("Something went wrong!");
    }
  }

  const fetchSchedules = async (doctorId) => {
    try {
      const response = await fetch(`https://backend.amarasinghemedicare.com/schedule/schedules?doctorId=${doctorId}`);
      const data = await response.json();

      if (response.ok) {
        setSchedules(data);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching schedules:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = (id) => {
    setDoctorId(id);
    setOpenModal(true)
    fetchDoctors(id);
    fetchSchedules(id);
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
      },
    },
  };

  const handleViewAppointments = async (scheduleId) => {
    setSelectedScheduleId(scheduleId);

    const response = await fetch(`https://backend.amarasinghemedicare.com/appointment/appointments/schedule/${scheduleId}`);
    const data = await response.json();
    setAppointments(data);
  };

  const columns = [
    { name: 'Doctor ID', selector: row => row.id, sortable: true },
    { name: 'Doctor Name', selector: row => row.fullName, sortable: true },
    { name: 'Experience', selector: row => row.experience, sortable: true },
    { name: 'Contact', selector: row => row.contact_number },
    {
      name: '',
      cell: row => (
        <div className="flex space-x-3 justify-center items-center">
          <button onClick={() => handleOpenModal(row.id)} className="flex text-xs items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-red text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            Create Message
            <FaEdit className='text-sm' />
          </button>
        </div>
      ),
    },
  ];

  const columnsAppointments = [
    {
      name: 'Patient Name', selector: row => `${row.firstName} ${row.lastName}`, sortable: true, cell: row => (
        <span
          className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
        >
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    {
      name: 'Time', selector: row => row.timeSlot, sortable: true, cell: row => (
        <span
          className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
        >
          {row.timeSlot}
        </span>
      ),
    },
    {
      name: 'Contact', selector: row => row.timeSlot, sortable: true, cell: row => (
        <span
          className={`${row.deleted_at ? 'opacity-50' : 'opacity-100'}`}
        >
          {row.mobileNo}
        </span>
      ),
    },
    {
      name: 'Status', selector: row => row.status, sortable: true, cell: row => (
        <span className={`${row.status.toLowerCase() === 'paid' ? 'bg-green' : 'bg-red'} w-16 rounded-md flex items-center justify-center text-white`}>
          {row.status}
        </span>
      ),
    },
    {
      name: 'Select',
      cell: (row) => (
        <div className="flex space-x-3 justify-center items-center">
          <input
            type="checkbox"
            className="accent-green"
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedAppointments([...selectedAppointments, row]);
              } else {
                setSelectedAppointments(
                  selectedAppointments.filter((item) => item.appointment_id !== row.appointment_id)
                );
              }
            }}
          />
        </div>
      ),
    }
  ];

  const sendBulkSms = async () => {
    if (selectedAppointments.length === 0) {
      toast.error("No appointments selected!");
      return;
    }

    try {
      const numberList = selectedAppointments.map((a) => a.mobileNo);

      const payload = {
        numberList,
        message: buildMessage(),
        sourceAddress: ''
      };

      const result = await axios.post(
        'https://backend.amarasinghemedicare.com/sms/send-sms',
        payload
      );

      if (result.data.success) {
        setSelectedAppointments([]);
        toast.success(result.data.message);
      } else {
        toast.error(result.data.message);
      }
    } catch (error) {
      const msg =
        error.response?.data?.message || "Something went wrong";
      toast.error(msg);
    } finally {
      setSelectedAppointments([]);
    }
  };

  const sendArrivalSms = async () => {
    if (selectedAppointments.length === 0) {
      toast.error("No appointments selected!");
      return;
    }

    try {
      const numberList = selectedAppointments.map((a) => a.mobileNo);

      const payload = {
        numberList,
        message: buildArrivalMessage(),
        sourceAddress: ''
      };

      const result = await axios.post(
        'https://backend.amarasinghemedicare.com/sms/send-sms',
        payload
      );

      if (result.data.success) {
        toast.success(result.data.message);
        setSelectedAppointments([]);
      } else {
        toast.error(result.data.message);
      }
    } catch (error) {
      const msg =
        error.response?.data?.message || "Something went wrong";
      toast.error(msg);
    } finally {
      setSelectedAppointments([]);
    }
  };

  const sendCustomSms = async () => {
    if (selectedAppointments.length === 0) {
      toast.error("No appointments selected!");
      return;
    }

    if (!customMessage.trim()) {
      toast.error("Please type a message!");
      return;
    }

    try {
      const numberList = selectedAppointments.map((a) => a.mobileNo);

      const payload = {
        numberList,
        message: customMessage,
        sourceAddress: ''
      };

      const result = await axios.post(
        'https://backend.amarasinghemedicare.com/sms/send-sms',
        payload
      );

      if (result.data.success) {
        toast.success(result.data.message);
        setCustomMessage(""); // clear message after success
      } else {
        toast.error(result.data.message);
      }

    } catch (error) {
      const msg =
        error.response?.data?.message || "Something went wrong";
      toast.error(msg);
    } finally {
      setSelectedAppointments([]);
    }
  };

  return (
    <>
      <Toaster />
      {error && <p>Error: {error}</p>}
      {categories.length === 0 ? (
        <p>Loading categories...</p>
      ) : (
        categories.map((category) => (
          <div key={category.id}>
            <h1 className='bg-[#4694C8] mt-6 w-fit p-1 rounded-sm text-gray-50 text-lg'>{category.eng_name}</h1>
            <DataTable
              columns={columns}
              data={category.Doctors}
              fixedHeader
              fixedHeaderScrollHeight="80vh"
              className="data-table"
              customStyles={customStyles}
              pagination
              paginationPerPage={20}
              paginationRowsPerPageOptions={[20]}
            />
          </div>
        ))
      )}

      <Modal show={openModal} size='6xl' onClose={onCloseModal} popup>
        <Modal.Header className='bg-fontDark' />
        <Modal.Body className='bg-gray-300'>
          <div className='flex flex-col sm:flex-col md:flex-row'>
            <div className='mb-10 px-0 sm:px-7 md:px-7 sm:w-full md:w-[23%] w-full'>
              <div className='p-5 bg-white flex flex-col items-center justify-center rounded-lg shadow-md gap-4'>
                <img className='w-32 h-32 sm:w-42 sm:h-42 md:w-52 md:h-40 rounded-full object-cover border border-fontDark'
                  src={
                    details?.profileImage
                      ? `https://backend.amarasinghemedicare.com/${details.profileImage.replace(/\\/g, '/')}`
                      : require('../../assest/images/Doctor.png') // Or use a public path if needed
                  } alt="" />

                <div className='flex flex-col items-center justify-center'>
                  <h1 className='text-base font-semibold text-fontDark'>{details.fullName}</h1>
                  <h3 className='text-sm'>-{details.qualifications}-</h3>
                </div>

                <button
                  className='flex items-center justify-center text-sm text-white uppercase font-light text-left bg-[#97CE4F] py-2 w-[100%] rounded-lg transform transition-transform duration-300 hover:scale-105'
                  onClick={() => navigate(`/details?doctorId=${doctorId}`, { state: details })}
                >
                  View Profile
                </button>
              </div>
            </div>

            <div className='bg-white my-2 sm:my-5 md:my-0 w-full sm:w-full md:w-[77%] rounded-lg shadow-md pb-7'>
              {isLoading ? (
                <p>Loading schedules...</p>
              ) : Array.isArray(schedules) && schedules.length > 0 ? (
                schedules.map((schedule) => {
                  const dataObj = new Date(schedule.date);
                  const options = { year: 'numeric', month: 'long', day: 'numeric' };
                  const formattedDate = dataObj.toLocaleDateString(undefined, options);
                  const weekday = dataObj.toLocaleDateString(undefined, { weekday: 'long' });

                  if (selectedScheduleId === schedule.id) {
                    return (
                      <div key={schedule.id} className="mt-7 px-7">
                        <h1>{weekday}, {formattedDate}</h1>
                        <div className="p-4 border rounded-md bg-gray-50">
                          <button className='bg-blue text-white px-4 mb-2 rounded-lg' onClick={() => { setSelectedScheduleId(null) }}>Back</button>
                          {appointments.length > 0 ? (
                            <>
                              <DataTable
                                columns={columnsAppointments}
                                data={appointments}
                                fixedHeader
                                fixedHeaderScrollHeight="80vh"
                                className="data-table"
                                customStyles={customStyles}
                                pagination
                                paginationPerPage={20}
                                paginationRowsPerPageOptions={[20]}
                              />

                              <div className='bg-[#EEFF01] mt-5 p-5 rounded-md border-[3px] border-black'>
                                <div className='p-2 rounded-md'>
                                  <h2 className='text-sm text-center font-semibold'>
                                    Dr {details.fullName} සමඟ හමුව සදහා {" "}
                                    {new Date(schedule.date).toLocaleDateString('en-GB')}{" "}
                                    වන දින ඔබට ලබාදී ඇති වෙලාව වන <span><input type="time" value={time} onChange={(e) => setTime(e.target.value)} /></span>ට පැමිණ සිටින්න.
                                    යම්කිසි හේතුවක් මත වෙන්කරවගත් වෙලාව අවලංගු කිරීමට අවශ්‍යනම් ඇමැතුමක් ලබාදී පෙර දැනුම්දීමක් කරනලෙස කරුණාවෙන් ඉල්ලා සිටිමු.
                                  </h2>

                                  <h2 className='text-sm text-center font-semibold mt-5'>Please arrive at {time.replace(":", ".")} at the time you have been given/given to meet Dr. {details.fullName}, {" "}{new Date(schedule.date).toLocaleDateString('en-GB')}{" "}. If you need to cancel your
                                    appointment for any reason, please call and give us prior notice. https://www.amarasinghemedicare.com/
                                  </h2>

                                  <button className='bg-blue w-full p-2 mt-5 rounded-md text-white' onClick={sendBulkSms}>Send Message</button>
                                </div>
                              </div>

                              <div className='bg-[#EEFF01] mt-5 p-5 rounded-md border-[3px] border-black'>
                                <div className='p-2 rounded-md'>
                                  <h2 className='text-sm text-center font-semibold'>
                                    Dr. {details.fullName} මහතා මේ මොහොතේ පැමිණ ඇති අතර ඔබට නියමිත වෙලාවට පැමිණ සිටින්න. මෙම මොහොතේ පරීක්ෂා කරන රෝගී අංකය දැන ගැනීමට පිවිසෙන්න https://www.amarasinghemedicare.com/
                                  </h2>

                                  <h2 className='text-sm text-center font-semibold mt-5'>
                                    Dr. {details.fullName} has arrived at the moment. Please arrive at your appointed time. Please access above link to see the patient number currently being examined.
                                  </h2>

                                  <button className='bg-blue w-full p-2 mt-5 rounded-md text-white' onClick={sendArrivalSms}>Send Message</button>
                                </div>
                              </div>

                              <div className='bg-[#EEFF01] mt-5 p-5 rounded-md border-[3px] border-black'>
                                <div className='p-2 rounded-md'>
                                  <textarea type="text" placeholder='Type here if you wants to create custom message' value={customMessage} onChange={(e) => setCustomMessage(e.target.value)} className='w-full p-2 rounded-lg' />

                                  <button className='bg-blue w-full p-2 mt-5 rounded-md text-white' onClick={sendCustomSms}>Send Message</button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <p className="text-xs">No appointments found.</p>
                          )}
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div key={schedule.id} className="mt-7 px-7">
                      <h1>{weekday}, {formattedDate}</h1>
                      <div className="flex items-center justify-between mt-2 rounded-lg shadow-lg p-2 bg-white border-l-8 border-green">
                        <img src={Logo} alt="" className="w-[7%] pl-2 shadow-md p-2 rounded-lg" />

                        <div className="ml-2">
                          <h1 className="text-xs font-semibold">Amarasingha Medicare</h1>
                          <h1 className="text-xs font-extralight">Eheliyagoda</h1>
                        </div>

                        <div className="flex sm:flex-row md:flex-row flex-col gap-4 sm:gap-0 md:gap-0 w-[80%] items-center justify-around">
                          <div className="flex flex-col items-center justify-center">
                            <h1 className="text-xs font-semibold text-blue">{schedule.start_time}</h1>
                            <h1 className="text-xs font-extralight">Starting</h1>
                          </div>

                          <div className="flex flex-col items-center justify-center">
                            <h1 className="text-xs font-semibold text-red">{schedule.end_time}</h1>
                            <h1 className="text-xs font-extralight">Ending</h1>
                          </div>

                          <div>
                            <h1 className="text-xs font-semibold text-green">Rs {schedule.doctor_fee} + Booking Fee</h1>
                            <h1 className="text-xs font-extralight">Fee</h1>
                          </div>

                          <div className="flex flex-col items-center justify-center">
                            <h1 className="text-xs font-semibold text-red">{schedule.bookedPatients}</h1>
                            <h1 className="text-xs font-extralight">Appointments</h1>
                          </div>

                          <div className='flex flex-col gap-2'>
                            <button
                              onClick={() => handleViewAppointments(schedule.id)}
                              className="text-xs text-white uppercase text-left bg-red py-2 px-7 rounded-lg transform transition-transform duration-300 hover:scale-105"
                            >
                              Message
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className='p-10'>No schedules available.</p>
              )}
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Message;